/**
 * The Events container
 */
import PropTypes from "prop-types";
import React from "react";
import { useSelector } from "react-redux";
import { withRouter } from "react-router-dom";
import { Container } from "reactstrap";
import Page from "../components/Page/Page-component";

/**
 * MintingSection container used as app default landing page
 */
const TermsAndConditions = (props, context) => {
  const lang = useSelector((state) => state.i18nState.lang);

  return (
    <Page id="termsandconditions" title={context.t("Terms & Conditions")}>
      <Container className="my-5">
        <div className="staticTextWrapper">
          {lang === "de" ? (
            <>
              <h1>Allgemeine Geschäftsbedingungen</h1>
              <ul className="list-unstyled">
                <li>
                  <h2>1. Einführung und Beschreibung des Service</h2>
                  <p>
                    Diese Webseite wird von Samsung Electronics GmbH, Am
                    Kronberger Hang 6, 65824 Schwalbach / Ts, Deutschland
                    („Samsung” oder „uns” oder „wir”) zur Verfügung gestellt.
                    Durch die Nutzung des auf dieser Webseite angebotenen
                    Service können Sie einen sog. Non-Fungible Token, der auf
                    einer Blockchain gespeichert ist („NFT“), für ein digitales
                    Kunstwerk oder digitales Sammlerstück („Kunst“) erstellen.
                    Der Vorgang des Erstellens eines solchen NFT über unsere
                    Webseite wird im Folgenden als „Minting“ bezeichnet. Ein
                    derartiger NFT wird im Folgenden „SAMSUNG NFT“ genannt. Ihre
                    Nutzung dieser Webseite, das Minting und/oder Ihre Nutzung
                    des SAMSUNG NFT (einschließlich eines späteren Kaufs oder
                    Verkaufs des SAMSUNG NFT) unterliegen den folgenden
                    Allgemeinen Geschäftsbedingungen („diese AGB“).
                  </p>
                </li>
                <li>
                  <h2>2. Webseite als Schnittstelle</h2>
                  <p>
                    Diese Webseite befindet sich nicht auf der Blockchain,
                    sondern dient als Schnittstelle, über die Sie das Minting
                    von SAMSUNG NFT durchführen und diese mit der zugehörigen
                    Blockchain verknüpfen können. Außerdem kann diese Webseite
                    als Schnittstelle verwendet werden, um Protokolle abzulegen,
                    die nach bestimmten unveränderlichen Regeln bei bestimmten
                    Ereignissen automatisch bestimmte Aktionen auslösen („Smart
                    Contracts“).
                  </p>
                </li>
                <li>
                  <h2>3. Minting</h2>
                  <ul className="list-unstyled">
                    <li>
                      <h3>3.1 Wallet</h3>
                      <p>
                        Sie können das Minting über diese Webseite durchführen,
                        indem Sie über Ihre Krypto Wallet auf diese Webseite
                        zugreifen und die in Ihrer Wallet angegebenen Aktionen
                        durchführen und bestätigen. Wir sind nicht
                        verantwortlich für die Validierung und Bestätigung von
                        Aktionen oder die Ausführung von Smart Contracts, die
                        Sie durchführen.
                      </p>
                    </li>
                    <li>
                      <h2>3.2 Haftungsausschluss und Risiken</h2>
                      <p>
                        Samsung haftet nicht für Schäden, die durch fehlerhafte
                        Transaktionen im Zusammenhang mit SAMSUNG NFT, die Sie
                        über Ihre Wallet durchführen, entstehen, es sei denn,
                        wir haben den Fehler zu vertreten. Wir haben keinen
                        Einfluss auf die zugrundeliegende Infrastruktur, die
                        Leistung oder die Funktionalität der jeweiligen
                        Blockchain, und wir können Transaktionen nicht
                        rückgängig machen, umkehren oder wiederherstellen. Die
                        auf dieser Webseite angebotenen Dienste sind (unabhängig
                        von der anwendbaren Rechtsordnung) kein Angebot zum Kauf
                        oder Verkauf von Aktien, Wertpapieren oder anderen
                        Finanzprodukten.
                      </p>
                    </li>
                  </ul>
                </li>
                <li>
                  <h2>4. Rechte an einem SAMSUNG NFT und an der Kunst</h2>
                  <ul className="list-unstyled">
                    <li>
                      <h3>4.1 Rechte am SAMSUNG NFT</h3>
                      <p>
                        Mit dem Minting oder einem Zweiterwerb eines SAMSUNG NFT
                        lösen Sie einen Eintrag auf der entsprechenden
                        Blockchain aus, der sich auf die zugrundeliegende Kunst
                        bezieht. Ihre Rechte in Bezug auf SAMSUNG NFT werden
                        durch die jeweilige Blockchain und den zugehörigen Smart
                        Contract geregelt. Durch das Minting eines SAMSUNG NFT
                        bestätigen Sie, dass Sie der Urheber der
                        zugrundeliegenden Kunst sind oder anderweitig dazu
                        berechtigt sind, ein SAMSUNG NFT für die betreffende
                        Kunst zu erstellen. Vorbehaltlich einer solchen
                        Bestätigung gewähren wir Ihnen bestimmte Rechte an dem
                        SAMSUNG NFT gemäß den nachfolgenden Bestimmungen
                        („Lizenz“).
                      </p>
                    </li>
                    <li>
                      <h3>4.2 Lizenz</h3>
                      <p>
                        Unter der Voraussetzung, dass Sie die Bedingungen dieser
                        AGB einhalten, gewähren wir Ihnen das weltweite,
                        gebührenfreie, nicht unterlizenzierbare, nicht-exklusive
                        Recht, das SAMSUNG NFT in Übereinstimmung mit und für
                        die in diesen AGB genannten Zwecke zu nutzen. Diese
                        Lizenz erlaubt es Ihnen, das SAMSUNG NFT zu nutzen, wenn
                        Sie die dem SAMSUNG NFT zugrundeliegende Kunst in einem
                        Online-Marktplatz, in sozialen Medien oder auf einer
                        Webseite für Ihre Zwecke ausstellen, sofern dieser
                        Online-Marktplatz, das soziale Medium oder die Webseite
                        Ihre Berechtigung an dem SAMSUNG NFT prüft. Die Ihnen an
                        dem SAMSUNG NFT eingeräumten Rechte sind nicht
                        übertragbar, es sei denn, Sie übertragen das SAMSUNG NFT
                        zusammen mit der zugrundeliegenden Kunst an einen
                        Erwerber. Ein Verkauf des SAMSUNG NFT (gemeinsam mit der
                        zugrundeliegenden Kunst) ist zulässig, darüber hinaus
                        sind Sie aber nicht berechtigt, das SAMSUNG NFT in
                        irgendeiner Art und Weise kommerziell zu verwerten. Die
                        Ihnen hierin eingeräumten Rechte sind auf die Zeit
                        beschränkt, in der Sie der rechtmäßige Inhaber dieser
                        SAMSUNG NFT sind. Sie verlieren Ihre Rechte, wenn Sie
                        das SAMSUNG NFT und/oder die zugrundeliegende Kunst
                        verkaufen oder anderweitig übertragen, sie zerstören,
                        Ihre Rechte daran anderweitig aufgeben oder, wenn wir
                        die Lizenz gemäß Ziffer 4.3 beenden. Andere Rechte als
                        die in diesen AGB ausdrücklich genannten werden Ihnen an
                        dem SAMSUNG NFT unter dieser Lizenz nicht eingeräumt.
                      </p>
                    </li>
                    <li>
                      <h3>4.3 Künftige Übertragungen von SAMSUNG NFTs</h3>
                      <p>
                        Sie erkennen an, dass Ihr SAMSUNG NFT nur aufgrund des
                        betreffenden, auf der jeweiligen Blockchain geführten
                        Datensatzes existiert. Jede Übertragung von SAMSUNG NFT
                        erfolgt innerhalb der jeweiligen Blockchain und nicht
                        über unsere Webseite. Für den Kauf oder Verkauf von
                        SAMSUNG NFT auf entsprechenden Marktplätzen können
                        zusätzliche Gebühren anfallen, die sich nach den jeweils
                        dort angegebenen Bedingungen richten. Die in diesen AGB
                        gewährte Lizenz berechtigt nur den jeweiligen
                        berechtigten Inhaber des SAMSUNG NFT; der/die
                        vorherige(n) Lizenznehmer verliert mit der Übertragung
                        sämtliche Rechte am SAMSUNG NFT.
                      </p>
                    </li>
                    <li>
                      <h3>4.4 Beendigung der Lizenz</h3>
                      <p>
                        Im Falle einer wesentlichen Verletzung der Bedingungen
                        dieser AGB sind wir berechtigt, Ihre gemäß dieser AGB
                        eingeräumten Rechte vollständig oder teilweise zu
                        kündigen. Mit Beendigung Ihrer Lizenz sind Sie
                        verpflichtet, jegliche Nutzung der in dieser Ziffer 4
                        gewährten Rechte einzustellen.
                      </p>
                    </li>
                    <li>
                      <h3>4.5 Keine Lizenz an Markenrechten</h3>
                      <p>
                        Zur Klarstellung: Das Minting von oder der Erwerb von
                        SAMSUNG NFT gewährt Ihnen kein Recht, eines unserer
                        Logos, Marken wie „Samsung“ oder irgendein anderes
                        unserer gewerblichen Schutzrechte zu verwenden. Sie
                        dürfen uns jedoch als Anbieter des Minting Service
                        benennen, über den das SAMSUNG NFT erstellt wurde.
                      </p>
                    </li>
                    <li>
                      <h3>4.6 Zusätzliche Funktionalitäten</h3>
                      <p>
                        Gegebenenfalls bieten wir Inhabern von SAMSUNG NFTs
                        zukünftig zusätzliche Funktionalitäten, Inhalte,
                        Gegenstände oder andere Vorteile an („Zusätzliche
                        Funktionalitäten“). Wir sind hierzu jedoch nicht
                        verpflichtet. Zusätzliche Funktionalitäten können
                        zusätzlichen Bedingungen unterliegen, die Ihnen zum
                        Zeitpunkt der Bereitstellung mitgeteilt werden können.
                      </p>
                    </li>
                  </ul>
                </li>
                <li>
                  <h2>5. Berechtigung und Einhaltung der Vorschriften</h2>
                  <p>
                    Sie versichern, dass Ihre Nutzung dieser Webseite sowie das
                    Minting von SAMSUNG NFT allen dafür in Ihrer Rechtsordnung
                    geltenden Gesetzen und Vorschriften entspricht.
                  </p>
                </li>
                <li>
                  <h2>6. Feedback</h2>
                  <p>
                    Sie haben die Möglichkeit, uns Kommentare, Fehlerberichte,
                    Ideen oder sonstiges Feedback zu diesen AGB, einem SAMSUNG
                    NFT oder dieser Webseite zu übermitteln (zusammenfassend
                    „Feedback“ genannt). Indem Sie uns Ihr Feedback senden,
                    erklären Sie sich damit einverstanden, dass wir dieses
                    Feedback in jeder von uns für angemessen erachteten Weise
                    ohne zusätzliche Vergütung verwenden dürfen. Sie gewähren
                    uns hiermit eine unbefristete, unwiderrufliche,
                    nicht-exklusive, weltweite Lizenz zur Einbindung und Nutzung
                    des Feedbacks für unsere Zwecke.
                  </p>
                </li>
                <li>
                  <h2>7. Beschränkung der Haftung</h2>
                  <p>
                    Wir haften unbeschränkt nach den gesetzlichen Vorschriften
                    für Schäden, die im Zusammenhang mit Ihrer Nutzung unserer
                    Webseite, dem Minting oder einem SAMSUNG NFT entstehen und
                    die auf einer vorsätzlichen oder grob fahrlässigen
                    Pflichtverletzung von uns beruhen. Gleiches gilt im Fall der
                    Verletzung des Lebens, des Körpers oder der Gesundheit,
                    einer Haftung nach dem Produkthaftungsgesetz (soweit
                    anwendbar) oder im Falle einer übernommenen Garantie. Soweit
                    in diesen AGB nicht anders bestimmt, haften wir nicht für
                    Schäden, die durch einfache Fahrlässigkeit von Samsung oder
                    eines gesetzlichen Vertreters oder eines Erfüllungsgehilfen
                    von Samsung verursacht wurden, unabhängig davon, ob diese
                    Schäden auf einer Verletzung einer vertraglichen Pflicht,
                    einer unerlaubten Handlung oder einer Verletzung von
                    sonstigen gesetzlichen Vorschriften beruhen. Wir haften
                    jedoch für eine leicht fahrlässige Verletzung von Pflichten,
                    die für die Erbringung unserer Leistungen wesentlich sind
                    und auf deren Erfüllung Sie typischerweise vertrauen und
                    vertrauen dürfen (Kardinalpflichten). Insoweit ist unsere
                    Haftung auf den vertragstypischen und vorhersehbaren Schaden
                    beschränkt.
                  </p>
                </li>
                <li>
                  <h2>8. Disclaimer</h2>
                  <p>
                    Wir gewährleisten nicht, dass der Zugriff auf die
                    Front-End-Schnittstelle unserer Webseite dauerhaft,
                    ununterbrochen, rechtzeitig oder sicher erfolgt, dass die
                    auf der Webseite enthaltenen Informationen richtig,
                    zuverlässig, vollständig oder aktuell sind oder dass diese
                    Webseite und die dahinterstehende Software frei von Fehlern,
                    Defekten, Viren oder anderen schädlichen Elementen sind.
                    Wenn Sie sich dazu entschließen, über unsere Webseite
                    SAMSUNG NFT zu minten oder auf einem Online-Marktplatz zu
                    verkaufen und/oder zu kaufen, werden alle finanziellen
                    Transaktionen, die Sie durchführen, ausschließlich über die
                    entsprechende Blockchain durchgeführt. Wir haben keinen
                    Einblick und keine Kontrolle über diese Zahlungen oder
                    Transaktionen und haften weder Ihnen noch Dritten gegenüber
                    für Ansprüche oder Schäden, die sich aus den Transaktionen
                    ergeben, die Sie über die jeweiligen Blockchains
                    durchführen.
                  </p>
                </li>
                <li>
                  <h2>9. Anwendbares Recht</h2>
                  <p>
                    Für diese AGB und die Beziehung zwischen Ihnen und uns sowie
                    jedem nachfolgenden Besitzer des SAMSUNG NFT und/oder der
                    jeweiligen Kunst gilt deutsches Recht (unter Ausschluss des
                    Kollisionsrechts und des UN-CISG).
                  </p>
                </li>
                <li>
                  <h2>10. Gerichtsstand</h2>
                  <p>
                    Für Streitigkeiten zwischen Ihnen und uns, die sich aus oder
                    in Verbindung mit diesen AGB ergeben, einschließlich solchen
                    über Ihren Zugang oder Ihre Nutzung dieser Webseite oder auf
                    damit zusammenhängende SAMSUNG NFT, ist ausschließlich der
                    Gerichtsstand Frankfurt / Main, Deutschland.
                  </p>
                </li>
                <li>
                  <h2>11. Unmittelbare Ausführung des Mintings</h2>
                  <p>
                    Mit dem Minting eines SAMSUNG NFT über diese Webseite
                    erklären Sie sich damit einverstanden, dass das Minting
                    unmittelbar ausgeführt wird. Widerrufsrechte bestehen nicht.
                  </p>
                </li>
                <li>
                  <h2>12. Übertragung/Abtretung</h2>
                  <p>
                    Wir sind berechtigt, die vertragliche Beziehung, die wir mit
                    Ihnen im Rahmen dieser AGB haben (oder damit verbundene
                    Rechte oder Pflichten), ohne Ihre Zustimmung an einen
                    Dritten zu übertragen.
                  </p>
                </li>
                <li>
                  <h2>13. Salvatorische Klausel</h2>
                  <p>
                    Sollte eine Bestimmung dieser AGB ungültig, nicht
                    durchsetzbar oder anderweitig nichtig sein, so hat dies
                    keine Auswirkungen auf die übrigen Bestimmungen dieser AGB.
                    Die ungültige, nicht durchsetzbare oder nichtige Bestimmung
                    gilt als durch eine gültige und durchsetzbare Bestimmung
                    ersetzt, die der ungültigen, nicht durchsetzbaren oder
                    nichtigen Bestimmung rechtlich am nächsten kommt.
                  </p>
                </li>
              </ul>
            </>
          ) : (
            <>
              <h1>SAMSUNG NFT PROJECT TERMS & CONDITIONS</h1>
              <ul className="list-unstyled">
                <li>
                  <h2>1. Introduction and Service</h2>
                  <p>
                    This website is provided by Samsung Electronics GmbH, Am
                    Kronberger Hang 6, 65824 Schwalbach / Ts., Germany
                    (&quot;Samsung&quot; or &quot;us&quot; or &quot;we&quot;).
                    By using the service offered on this website you can create
                    a functional non-fungible token which is running on a
                    blockchain (&quot;NFT&quot;) for a digital artwork or
                    digital collectible (&quot;Art&quot;). The process of
                    creating such NFT through this website is hereinafter
                    referred to as &quot;Minting&quot;. The NFT created is
                    hereinafter referred to as &quot;SAMSUNG NFT&quot;. Your use
                    of this website, the Minting, and/or your use of the SAMSUNG
                    NFT (including a subsequent purchase or sale of the SAMSUNG
                    NFT) are subject to the following terms and conditions
                    (&quot;these T&Cs&quot;).
                  </p>
                </li>
                <li>
                  <h2>2. Website as interface</h2>
                  <p>
                    This website is not stored on the blockchain but acts as an
                    interface for you to process the Minting of a SAMSUNG NFT
                    and interact with the related blockchain. Furthermore, this
                    interface can be used to store protocols that trigger
                    certain automated actions according to certain invariable
                    rules when certain events occur (&quot;Smart
                    Contracts&quot;).
                  </p>
                </li>
                <li>
                  <h2>3. Minting</h2>
                  <ul className="list-unstyled">
                    <li>
                      <h3>3.1 Wallet</h3>
                      <p>
                        You as the person executing the Minting can process the
                        transaction through this website by connecting your
                        crypto wallet and performing and confirming the actions
                        indicated in your wallet. We are not responsible for the
                        validation and confirmation of any action or Smart
                        Contract you execute through your own wallet which you
                        conduct at your own judgment and under your own control.
                      </p>
                    </li>
                    <li>
                      <h2>3.2 Disclaimer and Risks</h2>
                      <p>
                        Samsung does not take any liability if transactions
                        relating to the SAMSUNG NFT conducted by you through
                        your wallet fail, except where we have culpably caused
                        such failure. We have no control over the underlying
                        infrastructure and the performance and functionality of
                        the applicable blockchain and we cannot undo, reverse,
                        or restore any transaction. Nothing on this website
                        qualifies or is intended to be an offering of securities
                        in any jurisdiction nor does it constitute an offer or
                        an invitation to purchase shares, securities, or other
                        financial products.
                      </p>
                    </li>
                  </ul>
                </li>
                <li>
                  <h2>4. Rights pertaining to a SAMSUNG NFT and to the Art</h2>
                  <ul className="list-unstyled">
                    <li>
                      <h3>4.1 Ownership of the SAMSUNG NFT</h3>
                      <p>
                        With your Minting or secondary purchase of a SAMSUNG
                        NFT, you trigger an entry on the relevant blockchain,
                        which links to the underlying Art. Your rights
                        pertaining to the SAMSUNG NFT are governed by the
                        respective blockchain and the corresponding Smart
                        Contract.
                      </p>
                    </li>
                    <li>
                      <h3>4.2 License</h3>
                      <p>
                        Subject to your full compliance with these T&Cs, we
                        grant you the worldwide, royalty-free, not
                        sub-licensable, non-exclusive right to use the SAMSUNG
                        NFT strictly in accordance with, and for the purposes
                        stated in, these T&Cs. This License includes using the
                        SAMSUNG NFT when displaying the Art on a marketplace,
                        social media, or website for your personal use, provided
                        that such marketplace, social media, or website
                        cryptographically verifies that you are the owner of the
                        underlying SAMSUNG NFT. The rights granted to you in the
                        SAMSUNG NFT are non-transferrable unless you transfer
                        and assign the SAMSUNG NFT together with the underlying
                        Art to a secondary owner. Except for the sale of the
                        SAMSUNG NFT (together with the underlying Art), you have
                        no right to monetize the SAMSUNG NFT in any commercial
                        way.
                      </p>
                    </li>
                    <li>
                      <h3>4.3 Future transfers of SAMSUNG NFT</h3>
                      <p>
                        You acknowledge that your SAMSUNG NFT exists only by
                        virtue of the ownership record maintained on the
                        applicable blockchain. Any transfer of SAMSUNG NFTs
                        occurs within the relevant blockchain and not on our
                        website. A secondary sales royalty may apply as
                        indicated on the relevant platform you may use for the
                        sale or purchase of the SAMSUNG NFT on the secondary
                        market. You understand that the License is only granted
                        to the actual authorized licensee of the SAMSUNG NFT and
                        the previous licensee(s) will lose all rights in and to
                        the SAMSUNG NFT with its transfer.
                      </p>
                    </li>
                    <li>
                      <h3>4.4 Termination of the License</h3>
                      <p>
                        If you materially breach any of the provisions of these
                        T&Cs, we may terminate some or all of the rights granted
                        to you herein. Upon the termination of your License, you
                        shall cease all use of the rights granted in this
                        Section 4.
                      </p>
                    </li>
                    <li>
                      <h3>4.5 No license to use Samsung&apos;s trademarks</h3>
                      <p>
                        For clarity, the Minting or secondary acquisition of a
                        SAMSUNG NFT does not grant you any right to use any of
                        our logos, trademarks such as &quot;Samsung,&quot; or
                        any other of our intellectual property rights. You may,
                        however, refer to us as the source of the SAMSUNG NFT.
                      </p>
                    </li>
                    <li>
                      <h3>4.6 Additional Features</h3>
                      <p>
                        We may choose to make additional features, such as
                        access, content, items, or other benefits available to
                        owners of SAMSUNG NFTs (&quot;Additional
                        Features&quot;). However, we have no duty or obligation
                        to provide you with any such Additional Features.
                        Additional Features may be subject to additional terms
                        and conditions, which may be presented to you at the
                        time they are made available.
                      </p>
                    </li>
                  </ul>
                </li>
                <li>
                  <h2>5. Eligibility and compliance</h2>
                  <p>
                    You represent that your use of this website and the Minting
                    of SAMSUNG NFT complies with all laws and regulations
                    applicable to such use and Minting in your jurisdiction.
                  </p>
                </li>
                <li>
                  <h2>6. Feedback</h2>
                  <p>
                    You may choose to submit comments, bug reports, ideas, or
                    other feedback about these T&Cs, a SAMSUNG NFT, or this
                    website to us (collectively &quot;Feedback&quot;). By
                    sending us your Feedback, you agree that we may use such
                    Feedback in any way we see fit without additional
                    compensation. You hereby grant us a perpetual, irrevocable,
                    non-exclusive, worldwide license to incorporate and use the
                    Feedback for any purpose.
                  </p>
                </li>
                <li>
                  <h2>7. Limitation of Liability</h2>
                  <p>
                    Our statutory liability for damages incurred in connection
                    with your use of the website, the Minting service, or the
                    SAMSUNG NFT and arising from an intentional or grossly
                    negligent breach of duty by Samsung shall not be limited.
                    The same shall apply to our statutory liability for injury
                    to life, body, or health; under the Product Liability Act
                    (if applicable) or with respect to assumed guarantees.
                  </p>
                  <p>
                    Except as provided otherwise in these T&Cs, we shall not be
                    liable for damages, whether as a result of Samsung’s breach
                    or failure or otherwise, and whether arising in contract,
                    tort, or otherwise, in case of simple negligence committed
                    by Samsung or its legal representatives (gesetzliche
                    Vertreter) or a person performing obligations on behalf of
                    Samsung (Erfüllungsgehilfe).
                  </p>
                  <p>
                    Our liability for damages that arise out of a breach by
                    simple negligence of obligations that are essential for our
                    service and upon which you relied when using the servic
                  </p>
                </li>
                <li>
                  <h2>8. Disclaimers</h2>
                  <p>
                    We do not represent or warrant that access to the front-end
                    interface of our website will be continuous, uninterrupted,
                    timely, or secure; that the information contained on the
                    website will be accurate, reliable, complete, or current; or
                    that this website and the software behind it will be free
                    from errors, defects, viruses, or other harmful elements.
                  </p>
                  <p>
                    If you elect to mint a SAMSUNG NFT through this website or
                    sell and/or purchase on the secondary market, any financial
                    transactions that you engage in will be conducted solely
                    through the applicable blockchain. We will have no insight
                    into or control over any payments or transactions and will
                    have no liability to you or to any third party for any
                    claims or damages that may arise as a result of any
                    transactions that you engage or any other transactions that
                    you conduct via the applicable blockchain.
                  </p>
                </li>
                <li>
                  <h2>9. Applicable law</h2>
                  <p>
                    German law (excluding its conflict of law provisions and the
                    UNCISG) applies to these T&Cs and the relationship between
                    you and us and any subsequent owner of the SAMSUNG NFT
                    and/or the respective Art.
                  </p>
                </li>
                <li>
                  <h2>10. Jurisdiction</h2>
                  <p>
                    Should we ever have any dispute with you arising out of or
                    in connection with these T&Cs, including without limitation
                    your access or use of this website, or relating to any
                    SAMSUNG NFTs, such disputes shall be exclusively referred to
                    the courts competent for Frankfurt / Main, Germany.
                  </p>
                </li>
                <li>
                  <h2>11. Immediate execution of Minting service</h2>
                  <p>
                    By minting a SAMSUNG NFT through this website, you agree
                    that the minting of the SAMSUNG NFT shall be immediately
                    executed. Statutory revocation rights (if any) shall not
                    apply.
                  </p>
                </li>
                <li>
                  <h2>12. Transfer/ Assignment</h2>
                  <p>
                    We are entitled to freely assign the contractual
                    relationship we have with you under these T&Cs (or any
                    pertaining rights or obligations) to a third party without
                    your consent.
                  </p>
                </li>
                <li>
                  <h2>13. Severability</h2>
                  <p>
                    Should any provision of these T&Cs be invalid,
                    unenforceable, or otherwise void, this shall have no effect
                    on the remainder of these T&Cs. The invalid, unenforceable,
                    or otherwise void provision shall be deemed replaced by a
                    valid and enforceable provision coming as close as legally
                    possible to the invalid, unenforceable, or void provision.
                  </p>
                </li>
              </ul>
            </>
          )}
        </div>
      </Container>
    </Page>
  );
};

/**  define proptype for the 'translation' function  */
TermsAndConditions.contextTypes = {
  t: PropTypes.func,
};

/** export the component as redux connected component */
export default withRouter(TermsAndConditions);
